import { useEffect } from 'react';

import { MCP_HANDSHAKE_TIMEOUT_MS } from '../constants';

interface UseMcpIntegrationEffectsProps {
  frameKey: string;
  isFrameEnabled: boolean;
  onResetHandshake: () => void;
  isHandshakePending: boolean;
  onHandshakeTimeout: () => void;
}

export const useMcpIntegrationEffects = ({
  frameKey,
  isFrameEnabled,
  onResetHandshake,
  isHandshakePending,
  onHandshakeTimeout,
}: UseMcpIntegrationEffectsProps) => {
  useEffect(() => {
    onResetHandshake();
  }, [frameKey, isFrameEnabled, onResetHandshake]);

  useEffect(() => {
    if (!isHandshakePending) return;

    const timerId = window.setTimeout(
      onHandshakeTimeout,
      MCP_HANDSHAKE_TIMEOUT_MS
    );

    return () => {
      window.clearTimeout(timerId);
    };
  }, [isHandshakePending, onHandshakeTimeout]);
};
